import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

import logo from "assets/images/sportswear-erp.png";
import Avatar from "assets/images/users/avatar-1.jpg";

import { resetCompany } from "features/company/companySlice";
import useCompanyLogo from "features/Contexts/CompanyLogoContext";
import useVersion from "features/Contexts/VersionContext";
import { resetSettings } from "features/settings/settingsSlice";
import { logout } from "features/user/userSlice";
import { socket } from "../socket";
import ImageWIthSignedUrl from "./S3Utility/ImageWIthSignedUrl";
import {
  SHIPMENTS_PERMISSION,
  canUseShipments,
} from "pages/Sales/UpsTracking/permission";

function NavBar() {
  const user = useSelector((state) => state.user?.userInfo);
  const company = useSelector((state) => state.company?.company);

  let allowedModules = useMemo(() => {
    let modules =
      typeof company?.modulesList === "string"
        ? JSON.parse(company?.modulesList || "[]")
        : company?.modulesList || [];
    return modules;
  }, [company]);

  const location = useLocation();
  const { version } = useVersion();

  const companyLogo = useSelector(
    (state) => state?.company?.company?.companyLogo,
  );

  const { tempLogo } = useCompanyLogo();

  const dispatch = useDispatch();

  const [isConnected, setIsConnected] = useState(socket.connected);

  const [mockupsUnreadCount, setMockupsUnreadCount] = useState(0);

  const [newMockupMessage, setNewMockupMessage] = useState(false);

  const [expandedMenus, setExpandedMenus] = useState({
    SalesMenu: true, // Initially expanded since your code shows it with "show"
    utilitiesMenu: false, // Initially collapsed
    manufacturerMenu: false, // Initially collapsed for the new menu
    marketingMenu: false, // Initially collapsed for the marketing menu
    artManagerMenu: false,
  });

  // Toggle function that ensures only one menu is expanded at a time
  const toggleMenu = (menuId) => {
    // Create a new object with all menus set to false
    const newExpandedMenus = Object.keys(expandedMenus).reduce((acc, key) => {
      acc[key] = false;
      return acc;
    }, {});

    // Toggle the clicked menu (if it was true, it stays false; if it was false, it becomes true)
    newExpandedMenus[menuId] = !expandedMenus[menuId];

    setExpandedMenus(newExpandedMenus);
  };

  const userLogout = () => {
    dispatch(resetSettings());
    dispatch(resetCompany());
    dispatch(logout());
  };

  const checkCurrentPath = (path) => {
    if (Array.isArray(path)) {
      // If path is an array, check if any of the paths are included in the current pathname
      return path.some((p) => location.pathname.includes(p));
    }

    // If path is a string, check if the string representation of the
    // path is in the current location pathname

    return location.pathname?.replaceAll("/", "") === path;
  };

  useEffect(() => {
    function onConnect() {
      setIsConnected(true);
      console.log("navbar connected");
    }

    function onDisconnect() {
      setIsConnected(false);
      console.log("navbar disconnected");
    }

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);
    // Listen for 'newSms' event from the server

    // Listen for 'smsRead' event from the server
    // socket.on("smsRead", getUnreadSmsCount);

    // Listen for new Mockup msg

    return () => {
      // if (
      //   user?.permissions?.includes('sms_view') ||
      //   user?.permissions?.includes('sms_send') ||
      //   user?.roles === 'admin'
      // ) {
      //   getUnreadSmsCount();
      // }
      // socket.off("connect", onConnect);
      // socket.off("disconnect", onDisconnect);
      // socket.off("newSms", handleNewSms);
      // socket.off("mockups-app", getUnreadMockupCount);
    };
  }, [socket]);

  return (
    <>
      <div style={{ zIndex: 99999 }} className="leftside-menu">
        <div
          className="d-flex flex-column align-items-center justify-content-center "
          style={{
            height: 156,
            backgroundColor: "linear-gradient(135deg, #8f75da 0%, #727cf5 60%)",
          }}
        >
          <Link to="/dashboard" className="">
            <div className="mt-2 d-flex justify-content-center align-items-center">
              {tempLogo ? (
                <img src={tempLogo} alt="logo" height="100px" width="150px" />
              ) : companyLogo ? (
                <ImageWIthSignedUrl
                  path={companyLogo}
                  imgClasses={"mx-auto"}
                  imgStyle={{
                    height: "100px",
                    width: "150px",
                  }}
                />
              ) : (
                <img src={logo} alt="logo" height="100px" width="150px" />
              )}
            </div>
          </Link>
          <div className="text-white mt-2">
            <h5 className="m-0">{version}</h5>
          </div>
        </div>

        <div className="" id="leftside-menu-container" data-simplebar>
          <ul
            className="side-nav scrollbar-hide"
            style={{ height: "calc(100vh - 156px)", overflow: "auto" }}
          >
            <li className="dropdown notification-list">
              <Link
                className="d-flex align-items-center justify-content-between side-nav-link"
                data-bs-toggle="dropdown"
                href="#"
                role="button"
                aria-haspopup="false"
                aria-expanded="false"
              >
                <span className="account-user-avatar">
                  <img
                    src={Avatar}
                    alt={`${user?.firstName} ${user?.lastName}`}
                    className="rounded-circle me-1"
                    height={30}
                    width={30}
                  />
                </span>
                <span className="text-white text-uppercase flex-grow-1">{`${user?.firstName} ${user?.lastName}`}</span>
                <span className="text-white text-uppercase">
                  <i className="mdi mdi-cog text-end"></i>
                </span>
              </Link>
              <div className="dropdown-menu dropdown-menu-end dropdown-menu-animated topbar-dropdown-menu profile-dropdown">
                <div className=" dropdown-header noti-title">
                  <h6 className="text-overflow m-0">Welcome !</h6>
                </div>

                <Link href="#" className="dropdown-item notify-item">
                  <i className="mdi mdi-account-circle me-1"></i>
                  <span>My Account</span>
                </Link>

                {user?.roles === "admin" && (
                  <Link className="dropdown-item notify-item" to="/settings">
                    <i className="mdi mdi-account-edit me-1"></i>
                    <span>Settings</span>
                  </Link>
                )}

                <Link href="#" className="dropdown-item notify-item">
                  <i className="mdi mdi-lifebuoy me-1"></i>
                  <span>Support</span>
                </Link>

                <Link href="#" className="dropdown-item notify-item">
                  <i className="mdi mdi-lock-outline me-1"></i>
                  <span>Lock Screen</span>
                </Link>

                <Link
                  href="#"
                  className="dropdown-item notify-item"
                  onClick={() => userLogout()}
                >
                  <i className="mdi mdi-logout me-1"></i>
                  <span>Logout</span>
                </Link>
              </div>
            </li>

            <li className="side-nav-title side-nav-item">Navigation</li>
            <div className="scrollbar-hide">
              {(user?.permissions?.includes("password_add") ||
                user?.permissions?.includes("password_update") ||
                user?.permissions?.includes("password_delete") ||
                user?.permissions?.includes("password_all") ||
                user?.permissions?.includes("password_show_bid") ||
                user?.permissions?.includes("password_update_bid") ||
                user?.roles === "admin") && (
                <li className="">
                  <Link
                    to="password-manager"
                    className={`side-nav-link ${
                      checkCurrentPath("password-manager") ? "text-warning" : ""
                    }`}
                  >
                    <i className="ri-lock-password-fill"></i>
                    <span> Password Manager </span>
                  </Link>
                </li>
              )}

              {/* {(user?.permissions?.includes("temp_dashboard") ||
                user?.roles === "admin") && (
                <li className="">
                  <Link
                    to="status-board/temp-embroidery"
                    className={`side-nav-link ${
                      checkCurrentPath("status-board/temp-embroidery")
                        ? "text-warning"
                        : ""
                    }`}
                  >
                    <i className="mdi mdi-view-dashboard-outline"></i>
                    <span> Temp Board </span>
                  </Link>
                </li>
              )} */}

              {/*   Marketing Menu
               ********************************************* */}
              {user?.roles === "admin" && (
                <li className="side-nav-item d-none">
                  <a
                    data-bs-toggle="collapse"
                    href="#marketingMenu"
                    aria-expanded={
                      expandedMenus.marketingMenu ? "true" : "false"
                    }
                    aria-controls="marketingMenu"
                    className={`side-nav-link ${
                      expandedMenus.marketingMenu ? "bg-info bg-opacity-50" : ""
                    }`}
                    onClick={() => toggleMenu("marketingMenu")}
                    style={{ transitionDuration: "0.3s" }}
                  >
                    <i className="mdi mdi-bullhorn"></i>
                    <span> Marketing </span>
                    <span className="menu-arrow"></span>
                  </a>
                  <div
                    className={`collapse ${
                      expandedMenus.marketingMenu ? "show" : ""
                    } ps-3`}
                    id="marketingMenu"
                  >
                    <li className="side-nav-item">
                      <Link
                        to="marketing/leads"
                        className={`side-nav-link ${
                          checkCurrentPath(["marketing/leads"])
                            ? "text-warning"
                            : ""
                        }`}
                      >
                        <i className="mdi mdi-account-arrow-right"></i>
                        <span> Leads </span>
                      </Link>
                    </li>
                  </div>
                </li>
              )}

              {/*   Sales Menu
               ********************************************* */}
              {allowedModules?.includes("sales") &&
                (user?.permissions?.includes("customer_add") ||
                  user?.permissions?.includes("customer_update") ||
                  user?.permissions?.includes("customer_delete") ||
                  user?.permissions?.includes("quote_add") ||
                  user?.permissions?.includes("quote_update") ||
                  user?.permissions?.includes("quote_delete") ||
                  user?.permissions?.includes("work_orders_add") ||
                  user?.permissions?.includes("work_orders_update") ||
                  user?.permissions?.includes("work_orders_delete") ||
                  user?.permissions?.includes("work_orders_dataEntry") ||
                  user?.permissions?.includes("job_board") ||
                  user?.permissions?.includes("station_board") ||
                  user?.permissions?.includes("reports") ||
                  user?.permissions?.includes("utility_order_sheet") ||
                  user?.permissions?.includes("utility_label_printer") ||
                  // Sales -> Shipments alone is enough to show Sales (with
                  // only Shipments in it) -- user, 2026-10-21.
                  user?.permissions?.includes(SHIPMENTS_PERMISSION) ||
                  // Not "s_shipping" (old Sales -> Shipping, retired
                  // 2026-10-22): it showed Sales with nothing in it.
                  user?.permissions?.includes("wo_approvals") ||
                  user?.permissions?.includes("s_email") ||
                  user?.permissions?.includes("show_inbox") ||
                  user?.roles === "admin") && (
                  <li className="side-nav-item">
                    <a
                      data-bs-toggle="collapse"
                      href="#SalesMenu"
                      aria-expanded={expandedMenus.SalesMenu ? "true" : "false"}
                      aria-controls="SalesMenu"
                      className={`side-nav-link ${
                        expandedMenus.SalesMenu ? "bg-info bg-opacity-50" : ""
                      }`}
                      onClick={() => toggleMenu("SalesMenu")}
                      style={{
                        transitionDuration: "0.3s",
                        transitionTimingFunction: "ease-in-out",
                      }}
                    >
                      <i className="uil-copy-alt"></i>
                      <span> Sales </span>
                      <span className="menu-arrow"></span>
                    </a>
                    <div
                      className={`collapse ${
                        expandedMenus.SalesMenu ? "show" : ""
                      } ps-3`}
                      id="SalesMenu"
                    >
                      {/* {(user?.roles === "admin" ||
                      user?.permissions?.includes("s_email")) && (
                      <li>
                        <a
                          href="/email/inbox"
                          target="_blank"
                          className={`side-nav-link ${
                            checkCurrentPath("email/inbox")
                              ? "text-warning"
                              : ""
                          }`}
                        >
                          <i className="mdi mdi-email"></i>
                          <span> Emails </span>
                        </a>
                      </li>
                    )} */}
                      {(user?.permissions?.includes("customer_add") ||
                        user?.permissions?.includes("customer_update") ||
                        user?.permissions?.includes("customer_delete") ||
                        user?.roles === "admin") && (
                        <li className="side-nav-item">
                          <Link
                            to={`customer?page=1&location=${
                              user.defaultLocation
                                ? user.defaultLocation
                                : "all"
                            }`}
                            className={`side-nav-link ${
                              checkCurrentPath("customer") ? "text-warning" : ""
                            }`}
                          >
                            <i className="ri-team-fill"></i>
                            <span> Customers </span>
                          </Link>
                        </li>
                      )}

                      {(user?.permissions?.includes("quote_add") ||
                        user?.permissions?.includes("quote_update") ||
                        user?.permissions?.includes("quote_delete") ||
                        user?.roles === "admin") && (
                        <li>
                          <Link
                            to="quotes/all?page=1"
                            className={`side-nav-link ${
                              checkCurrentPath(["quotes"]) ? "text-warning" : ""
                            }`}
                          >
                            <i className="mdi mdi-format-list-numbered"></i>
                            <span> Quotes </span>
                          </Link>
                        </li>
                      )}
                      {(user?.permissions?.includes("work_orders_add") ||
                        user?.permissions?.includes("work_orders_update") ||
                        user?.permissions?.includes("work_orders_delete") ||
                        user?.permissions?.includes("work_orders_dataEntry") ||
                        user?.roles === "admin") && (
                        <>
                          <li>
                            <Link
                              to={`work-orders/all?page=1&limit=10${
                                user.defaultLocation
                                  ? "&location=" + user.defaultLocation
                                  : ""
                              }`}
                              className={`side-nav-link ${
                                checkCurrentPath(["work-orders"]) &&
                                !checkCurrentPath(["work-orders/invoice-ready"])
                                  ? "text-warning"
                                  : ""
                              }`}
                            >
                              <i className="mdi mdi-list-status"></i>
                              <span>W-Orders </span>
                            </Link>
                          </li>
                        </>
                      )}

                      {/* Order (user, 2026-11-03): Customers, Quotes, W-Orders, Pending
                          Invoices, Approvals, Shipments, Station Board, Job
                          Board; Pending Invoices shows as "Invoices" and
                          Station Board as "Workflow" (user, 2026-11-03).
                          Pending Invoices was a W Orders tab (2026-10-29). */}
                      {(user?.permissions?.includes("work_orders_add") ||
                        user?.permissions?.includes("work_orders_update") ||
                        user?.permissions?.includes("work_orders_delete") ||
                        user?.permissions?.includes("work_orders_dataEntry") ||
                        user?.roles === "admin") && (
                        <li>
                          <Link
                            to={`work-orders/invoice-ready?page=1&limit=10${
                              user.defaultLocation
                                ? "&location=" + user.defaultLocation
                                : ""
                            }`}
                            className={`side-nav-link ${
                              checkCurrentPath([
                                "work-orders/invoice-ready",
                                "pending-invoices",
                              ])
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-file-clock-outline"></i>
                            <span>Invoices</span>
                          </Link>
                        </li>
                      )}

                      {(user?.permissions?.includes("wo_approvals") ||
                        user?.roles === "admin") && (
                        <li>
                          <Link
                            to={`sales/wo-approvals`}
                            className={`side-nav-link ${
                              checkCurrentPath("sales/wo-approvals")
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-check-circle"></i>
                            <span>Approvals</span>
                          </Link>
                        </li>
                      )}

                      {canUseShipments(user) && (
                        <li>
                          <Link
                            to="sales/tracking-info"
                            className={`side-nav-link ${
                              checkCurrentPath("sales/tracking-info")
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-truck-delivery"></i>
                            <span>Shipments</span>
                          </Link>
                        </li>
                      )}

                      {/* Station Board (user, 2026-11-02). */}
                      {(user?.permissions?.includes("station_board") ||
                        user?.roles === "admin") && (
                        <li>
                          <Link
                            to="station-board"
                            className={`side-nav-link ${
                              checkCurrentPath("station-board")
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-view-column-outline"></i>
                            <span>Workflow</span>
                          </Link>
                        </li>
                      )}

                      {(user?.permissions?.includes("job_board") ||
                        user?.roles === "admin") && (
                        <li>
                          <Link
                            to={`status-board${
                              user.defaultJobBoardLocation
                                ? "?location=" + user.defaultJobBoardLocation
                                : ""
                            }`}
                            className={`side-nav-link ${
                              checkCurrentPath("status-board")
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-monitor-dashboard"></i>
                            <span>Job Board</span>
                          </Link>
                        </li>
                      )}

                      {/* {(us0er?.permissions?.includes("s_shipping") ||
                      user?.roles === "admin") && (
                      <li>
                        <Link
                          to={`sales/shipments/details`}
                          className={`side-nav-link ${
                            checkCurrentPath("sales/shipments/details")
                              ? "text-warning"
                              : ""
                          }`}
                        >
                          <i className="mdi mdi-truck"></i>
                          <span>Shipping</span>
                        </Link>
                      </li>
                    )} */}

                      {/* Sales Utilities Submenu */}
                      {(user?.roles === "admin" ||
                        user?.permissions?.includes("utility_order_sheet") ||
                        user?.permissions?.includes("utility_label_printer") ||
                        user?.permissions?.includes("utility_bundle_sync") ||
                        user?.permissions?.includes("s_purchasing") ||
                        user?.permissions?.includes("approval_product") ||
                        user?.permissions?.includes("reports")) && (
                        <li className="side-nav-item">
                          <a
                            data-bs-toggle="collapse"
                            href="#salesUtilitiesMenu"
                            aria-expanded="false"
                            aria-controls="salesUtilitiesMenu"
                            className={`side-nav-link ${
                              checkCurrentPath([
                                "order-sheet",
                                "label-printer",
                                "nova-shipping",
                              ])
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-tools"></i>
                            <span> Utilities </span>
                            <span className="menu-arrow"></span>
                          </a>
                          <div className="collapse" id="salesUtilitiesMenu">
                            <ul className="side-nav-second-level">
                              {(user?.roles === "admin" ||
                                user?.permissions?.includes(
                                  "utility_bundle_sync",
                                )) && (
                                <li>
                                  <Link
                                    to="sales/nova-shipping"
                                    className={`side-nav-link ${
                                      checkCurrentPath("sales/nova-shipping")
                                        ? "text-warning"
                                        : ""
                                    }`}
                                  >
                                    <i className="mdi mdi-package-variant-closed"></i>
                                    <span> Nova Shipping </span>
                                  </Link>
                                </li>
                              )}
                              {(user?.roles === "admin" ||
                                user?.permissions?.includes(
                                  "utility_label_printer",
                                )) && (
                                <li>
                                  <Link
                                    to="label-printer"
                                    className={`side-nav-link ${
                                      checkCurrentPath("label-printer")
                                        ? "text-warning"
                                        : ""
                                    }`}
                                  >
                                    <i className="ri-article-fill"></i>
                                    <span> Label Printer </span>
                                  </Link>
                                </li>
                              )}
                              {/* {(user?.roles === "admin" ||
                              user?.permissions?.includes([
                                "approval_product",
                              ])) && (
                              <li>
                                <Link
                                  to="sales/approval-products"
                                  className={` ${
                                    checkCurrentPath("sales/approval-products")
                                      ? "text-warning"
                                      : ""
                                  }`}
                                >
                                  <i className="mdi mdi-account-clock me-1"></i>
                                  <span> Approval Products </span>
                                </Link>
                              </li>
                            )} */}
                              {(user?.roles === "admin" ||
                                user?.permissions?.includes(
                                  "utility_order_sheet",
                                )) && (
                                <li className="side-nav-item">
                                  <Link
                                    to="order-sheet"
                                    className={`side-nav-link ${
                                      checkCurrentPath("order-sheet")
                                        ? "text-warning"
                                        : ""
                                    }`}
                                  >
                                    <i className="mdi mdi-google-spreadsheet"></i>
                                    <span> Order Sheet </span>
                                  </Link>
                                </li>
                              )}
                              {/* Products */}
                              <li className="side-nav-item">
                                <Link
                                  to="sales/products"
                                  className={`side-nav-link ${
                                    checkCurrentPath(["sales/products"])
                                      ? "text-warning"
                                      : ""
                                  }`}
                                >
                                  <i className="mdi mdi-tshirt-crew-outline"></i>
                                  <span> Products </span>
                                </Link>
                              </li>

                              {(user?.permissions?.includes("sales/reports") ||
                                user?.roles === "admin") && (
                                <li className="side-nav-item">
                                  <Link
                                    to="sales/reports"
                                    className={`side-nav-link ${
                                      checkCurrentPath("sales/reports")
                                        ? "text-warning"
                                        : ""
                                    }`}
                                  >
                                    <i className="mdi mdi-file-document-multiple"></i>
                                    <span> Reports </span>
                                  </Link>
                                </li>
                              )}
                              {(user?.permissions?.includes("s_purchasing") ||
                                user?.roles === "admin") && (
                                <li className="side-nav-item">
                                  <Link
                                    to="sales/purchasing"
                                    className={`side-nav-link ${
                                      checkCurrentPath("sales/purchasing")
                                        ? "text-warning"
                                        : ""
                                    }`}
                                  >
                                    <i className="mdi mdi-cart-outline"></i>
                                    <span> Purchasing </span>
                                  </Link>
                                </li>
                              )}
                            </ul>
                          </div>
                        </li>
                      )}
                    </div>
                  </li>
                )}

              {/*   Manufacturer Menu
               ********************************************* */}
              {allowedModules?.includes("manufacturing") &&
                (user?.permissions?.includes("m_pswd_add") ||
                  user?.permissions?.includes("m_wo_update") ||
                  user?.permissions?.includes("m_pswd_delete") ||
                  // work order: m_wo_
                  user?.permissions?.includes("m_wo_add") ||
                  user?.permissions?.includes("m_wo_update") ||
                  user?.permissions?.includes("m_wo_delete") ||
                  // vendor: m_vendor_
                  user?.permissions?.includes("m_vendor_add") ||
                  user?.permissions?.includes("m_vendor_update") ||
                  user?.permissions?.includes("m_vendor_delete") ||
                  // material stock: m_material_stock_
                  user?.permissions?.includes("m_material_stock") ||
                  // products: m_product_
                  user?.permissions?.includes("m_product") ||
                  // attendance: m_attendance_
                  user?.permissions?.includes("m_attendance") ||
                  // Efs Invoice
                  user?.permissions?.includes("m_efs_invoice") ||
                  user?.roles === "admin") && (
                  <li className="side-nav-item">
                    <a
                      data-bs-toggle="collapse"
                      href="#manufacturerMenu"
                      aria-expanded={
                        expandedMenus.manufacturerMenu ? "true" : "false"
                      }
                      aria-controls="manufacturerMenu"
                      className={`side-nav-link ${
                        expandedMenus.manufacturerMenu
                          ? "bg-info bg-opacity-50"
                          : ""
                      }`}
                      onClick={() => toggleMenu("manufacturerMenu")}
                      style={{
                        transitionDuration: "0.3s",
                        transitionTimingFunction: "ease-in-out",
                      }}
                    >
                      <i className="mdi mdi-factory"></i>
                      <span> Manufacturing </span>
                      <span className="menu-arrow"></span>
                    </a>
                    <div
                      className={`collapse ${
                        expandedMenus.manufacturerMenu ? "show" : ""
                      } ps-3`}
                      id="manufacturerMenu"
                    >
                      {/* WorkOrder */}
                      {(user?.permissions?.includes("m_wo_add") ||
                        user?.permissions?.includes("m_wo_update") ||
                        user?.permissions?.includes("m_wo_delete") ||
                        user?.roles === "admin") && (
                        <li className="side-nav-item">
                          <Link
                            to="manufacturer/m-orders"
                            className={`side-nav-link ${
                              checkCurrentPath(["manufacturer/m-orders"])
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-file-document"></i>
                            <span> M - Orders </span>
                          </Link>
                        </li>
                      )}

                      {/* Wages */}
                      {(user?.permissions?.includes("m_wages") ||
                        user?.roles === "admin") && (
                        <li className="side-nav-item">
                          <Link
                            to="manufacturer/wages"
                            className={`side-nav-link ${
                              checkCurrentPath(["manufacturer/wages"])
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-currency-usd"></i>
                            <span> Wages </span>
                          </Link>
                        </li>
                      )}

                      {/* Vendors */}
                      {(user?.permissions?.includes("m_vendor_add") ||
                        user?.permissions?.includes("m_vendor_update") ||
                        user?.permissions?.includes("m_vendor_delete") ||
                        user?.roles === "admin") && (
                        <li className="side-nav-item">
                          <Link
                            to="manufacturer/vendors"
                            className={`side-nav-link ${
                              checkCurrentPath(["manufacturer/vendors"])
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-account"></i>
                            <span> Vendors </span>
                          </Link>
                        </li>
                      )}

                      {/* Material Stock */}
                      {(user?.permissions?.includes("m_material_stock") ||
                        user?.roles === "admin") && (
                        <li className="side-nav-item">
                          <Link
                            to="manufacturer/material-stock"
                            className={`side-nav-link ${
                              checkCurrentPath(["manufacturer/material-stock"])
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-archive"></i>
                            <span> Material Stock </span>
                          </Link>
                        </li>
                      )}

                      {/* Efs Invoice */}
                      {(user?.permissions?.includes("m_efs_invoice") ||
                        user?.roles === "admin") && (
                        <li className="side-nav-item">
                          <a
                            data-bs-toggle="collapse"
                            href="#efsMenu"
                            aria-expanded="false"
                            aria-controls="efsMenu"
                            className={`side-nav-link ${
                              checkCurrentPath([
                                "manufacturer/efs-imports",
                                "manufacturer/efs-analysis-card",
                              ])
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-file-document"></i>
                            <span> EFS </span>
                            <span className="menu-arrow"></span>
                          </a>
                          <div className="collapse" id="efsMenu">
                            <ul className="side-nav-second-level">
                              <li>
                                <Link
                                  to="manufacturer/efs-imports"
                                  className={`side-nav-link ${
                                    checkCurrentPath([
                                      "manufacturer/efs-imports",
                                    ])
                                      ? "text-warning"
                                      : ""
                                  }`}
                                >
                                  <span> Imports </span>
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="manufacturer/efs-analysis-card"
                                  className={`side-nav-link ${
                                    checkCurrentPath([
                                      "manufacturer/efs-analysis-card",
                                    ])
                                      ? "text-warning"
                                      : ""
                                  }`}
                                >
                                  <span> Analysis card </span>
                                </Link>
                              </li>
                              <li>
                                <Link
                                  to="manufacturer/efs-invoice"
                                  className={`side-nav-link ${
                                    checkCurrentPath([
                                      "manufacturer/efs-invoice",
                                    ])
                                      ? "text-warning"
                                      : ""
                                  }`}
                                >
                                  <span> Efs Invoice </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </li>
                      )}

                      {(user?.permissions?.includes("m_day_book") ||
                        user?.roles === "admin") && (
                        <li className="side-nav-item">
                          <a
                            data-bs-toggle="collapse"
                            href="#manufacturerAccountsMenu"
                            aria-expanded="false"
                            aria-controls="manufacturerAccountsMenu"
                            className={`side-nav-link ${
                              checkCurrentPath([
                                "manufacturer/accounts/pay-book",
                              ])
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-wallet"></i>
                            <span> Accounts </span>
                            <span className="menu-arrow"></span>
                          </a>
                          <div
                            className="collapse"
                            id="manufacturerAccountsMenu"
                          >
                            <ul className="side-nav-second-level">
                              <li>
                                <Link
                                  to="manufacturer/accounts/pay-book"
                                  className={`side-nav-link ${
                                    checkCurrentPath([
                                      "manufacturer/accounts/pay-book",
                                    ])
                                      ? "text-warning"
                                      : ""
                                  }`}
                                >
                                  <span> Day Book </span>
                                </Link>
                              </li>
                            </ul>
                          </div>
                        </li>
                      )}

                      {/* Products */}
                      {(user?.permissions?.includes("m_product") ||
                        user?.roles === "admin") && (
                        <li className="side-nav-item">
                          <Link
                            to="manufacturer/products"
                            className={`side-nav-link ${
                              checkCurrentPath(["manufacturer/products"])
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-tshirt-crew-outline"></i>
                            <span> Products </span>
                          </Link>
                        </li>
                      )}

                      {/* Manufacturer Utilities Submenu */}
                      {(user?.roles === "admin" ||
                        user?.permissions?.includes("m_attendance") ||
                        user?.permissions?.includes("m_loss_run_report") ||
                        user?.permissions?.includes("m_pk_shipments")) && (
                        <li className="side-nav-item">
                          <a
                            data-bs-toggle="collapse"
                            href="#manufacturerUtilitiesMenu"
                            aria-expanded="false"
                            aria-controls="manufacturerUtilitiesMenu"
                            className={`side-nav-link ${
                              checkCurrentPath(["attendance"])
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <i className="mdi mdi-tools"></i>
                            <span> Utilities </span>
                            <span className="menu-arrow"></span>
                          </a>
                          <div
                            className="collapse"
                            id="manufacturerUtilitiesMenu"
                          >
                            <ul className="ms-0 me-0 my-1 mb-2 side-nav-second-level">
                              {/* Password Manager */}
                              {(user?.permissions?.includes("m_pswd_add") ||
                                user?.permissions?.includes("m_pswd_update") ||
                                user?.permissions?.includes("m_pswd_delete") ||
                                user?.roles === "admin") && (
                                <li className="">
                                  <Link
                                    to="m-passwords"
                                    className={`mx-0 pe-0 ${
                                      checkCurrentPath("m-passwords")
                                        ? "text-warning"
                                        : ""
                                    }`}
                                  >
                                    <i className="mdi mdi-lock me-1"></i>
                                    <span> Password Manager </span>
                                  </Link>
                                </li>
                              )}
                              {(user?.roles === "admin" ||
                                user?.permissions?.includes(
                                  "m_attendance",
                                )) && (
                                <li>
                                  <Link
                                    to="attendance"
                                    className={`mx-0 pe-0 ${
                                      checkCurrentPath("attendance")
                                        ? "text-warning"
                                        : ""
                                    }`}
                                  >
                                    <i className="mdi mdi-account-clock me-1"></i>
                                    <span>Time & Attendance</span>
                                  </Link>
                                </li>
                              )}

                              {(user?.roles === "admin" ||
                                user?.permissions?.includes(
                                  "m_loss_run_report",
                                )) && (
                                <li>
                                  <Link
                                    to="manufacturer/loss-run-report"
                                    className={`mx-0 pe-0 ${
                                      checkCurrentPath(
                                        "manufacturer/loss-run-report",
                                      )
                                        ? "text-warning"
                                        : ""
                                    }`}
                                  >
                                    <i className="mdi mdi-file-document me-1"></i>
                                    <span>Loss Run Report</span>
                                  </Link>
                                </li>
                              )}

                              {/* PK-DHL / PK-UPS shipments report (user, 2026-10-30) */}
                              {(user?.roles === "admin" ||
                                user?.permissions?.includes(
                                  "m_pk_shipments",
                                )) && (
                                <li>
                                  <Link
                                    to="manufacturer/pk-shipments"
                                    className={`mx-0 pe-0 ${
                                      checkCurrentPath(
                                        "manufacturer/pk-shipments",
                                      )
                                        ? "text-warning"
                                        : ""
                                    }`}
                                  >
                                    <i className="mdi mdi-truck-delivery me-1"></i>
                                    <span>PK Shipments</span>
                                  </Link>
                                </li>
                              )}

                            </ul>
                          </div>
                        </li>
                      )}
                    </div>
                  </li>
                )}

              {/*   Miscellaneous Menu (formerly Utilities)
               ********************************************* */}
              {allowedModules?.includes("miscellaneous") &&
                user?.roles === "admin" && (
                  <li className="side-nav-item">
                    <a
                      data-bs-toggle="collapse"
                      href="#utilitiesMenu"
                      aria-expanded={
                        expandedMenus.utilitiesMenu ? "true" : "false"
                      }
                      aria-controls="utilitiesMenu"
                      className={`side-nav-link ${
                        expandedMenus.utilitiesMenu
                          ? "bg-info bg-opacity-50"
                          : ""
                      }`}
                      onClick={() => toggleMenu("utilitiesMenu")}
                      style={{ transitionDuration: "0.3s" }}
                    >
                      <i className="uil-copy-alt"></i>
                      <span> Miscellaneous </span>
                      <span className="menu-arrow"></span>
                    </a>
                    <div
                      className={`collapse ${
                        expandedMenus.utilitiesMenu ? "show" : ""
                      } ps-3`}
                      id="utilitiesMenu"
                    >
                      {/* {(user?.permissions?.includes("utility_mockups") ||
                      user?.roles === "admin") && (
                      <li className="side-nav-item">
                        <Link
                          to="mockups-list"
                          className={`side-nav-link ${
                            checkCurrentPath("mockups-list")
                              ? "text-warning"
                              : ""
                          }`}
                        >
                          <i className="ri-palette-fill"></i>
                          <span> Mockups</span>
                          <span className="badge bg-danger float-end">
                            {newMockupMessage && `new`}
                          </span>
                        </Link>
                      </li>
                    )} */}

                      {/* {user?.roles === "admin" && (
                      <li>
                        <Link
                          to="shipment-label"
                          className={`side-nav-link ${
                            checkCurrentPath("shipment-label")
                              ? "text-warning"
                              : ""
                          }`}
                        >
                          <i className="mdi mdi-truck"></i>
                          <span> Shipment Label </span>
                        </Link>
                      </li>
                    )} */}

                      <ul className="side-nav-second-level">
                        {/* {user?.roles === "admin" && false && (
                        <li>
                          <Link
                            to="excel-functions"
                            className={`side-nav-link ${
                              checkCurrentPath("excel-functions")
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            Excel functions
                          </Link>
                        </li>
                      )}

                      {(user?.permissions?.includes("tracking") ||
                        user?.roles === "admin") && (
                        <li>
                          <Link
                            to="tracking"
                            className={`side-nav-link ${
                              checkCurrentPath("tracking") ? "text-warning" : ""
                            }`}
                          >
                            Tracking
                          </Link>
                        </li>
                      )} */}

                        {user?.roles === "admin" && (
                          <li>
                            <Link
                              to="price-calculator"
                              className={`side-nav-link ${
                                checkCurrentPath("price-calculator")
                                  ? "text-warning"
                                  : ""
                              }`}
                            >
                              Price Calculator
                            </Link>
                          </li>
                        )}

                        {user?.roles === "admin" && (
                          <li>
                            <Link
                              to="/test/videos"
                              className={`side-nav-link ${
                                checkCurrentPath("/test/videos")
                                  ? "text-warning"
                                  : ""
                              }`}
                            >
                              Video Record (Test)
                            </Link>
                          </li>
                        )}

                        {/* {user?.roles === "admin" && true && (
                        <li className="side-nav-item">
                          <Link
                            to="pdf-test"
                            className={`side-nav-link ${
                              checkCurrentPath("pdf-test") ? "text-warning" : ""
                            }`}
                          >
                            <span> Pdf Testing </span>
                          </Link>
                        </li>
                      )}
                      {user?.roles === "admin" && false && (
                        <li>
                          <Link
                            to="electron-test"
                            className={`side-nav-link ${
                              checkCurrentPath("electron-test")
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            <span> Electron Testing </span>
                          </Link>
                        </li>
                      )}
                      {(user?.permissions?.includes("how_to_videos") ||
                        user?.roles === "admin") && (
                        <li>
                          <Link
                            to="how-to-videos"
                            className={`side-nav-link ${
                              checkCurrentPath("how-to-videos")
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            How To Videos
                          </Link>
                        </li>
                      )}
                      {user?.roles === "admin" && (
                        <li>
                          <Link
                            to="testing-components"
                            className={`side-nav-link ${
                              checkCurrentPath("testing-components")
                                ? "text-warning"
                                : ""
                            }`}
                          >
                            Testing Components
                          </Link>
                        </li>
                      )} */}
                      </ul>
                    </div>
                  </li>
                )}

              {/*   Art Manager Menu
               *
               * Top level and LAST, per the 2026-09-11 spec. Admin-only for
               * now; a permission can gate it later through the Permissions
               * page. Deliberately not tied to modulesList -- one test page
               * does not earn a module flag.
               *
               * The pages under it are meant to be opened inside the ERP
               * Artwork Manager desktop app (docs/erp-artwork-manager.md);
               * in a plain browser they render but the desktop-only actions
               * stay disabled.
               ********************************************* */}
              {user?.roles === "admin" && (
                <li className="side-nav-item">
                  <a
                    data-bs-toggle="collapse"
                    href="#artManagerMenu"
                    aria-expanded={
                      expandedMenus.artManagerMenu ? "true" : "false"
                    }
                    aria-controls="artManagerMenu"
                    className={`side-nav-link ${
                      expandedMenus.artManagerMenu
                        ? "bg-info bg-opacity-50"
                        : ""
                    }`}
                    onClick={() => toggleMenu("artManagerMenu")}
                    style={{ transitionDuration: "0.3s" }}
                  >
                    <i className="uil-folder-open"></i>
                    <span> Art Manager </span>
                    <span className="menu-arrow"></span>
                  </a>
                  <div
                    className={`collapse ${
                      expandedMenus.artManagerMenu ? "show" : ""
                    } ps-3`}
                    id="artManagerMenu"
                  >
                    <ul className="side-nav-second-level">
                      <li>
                        <Link
                          to="/art-manager/test"
                          className={`side-nav-link ${
                            checkCurrentPath("/art-manager/test")
                              ? "text-warning"
                              : ""
                          }`}
                        >
                          <i className="uil-flask"></i>
                          <span> Test </span>
                        </Link>
                      </li>
                    </ul>
                  </div>
                </li>
              )}
            </div>
          </ul>
        </div>
      </div>
    </>
  );
}

export default NavBar;
